export default [
  [
    {
      name: '調查探勘',
      id: '調查探勘',
      list: [{ name: '環境調查', id: '調查探勘-環境調查' }, { name: '地質鑽探', id: '調查探勘-地質鑽探' }, { name: '其它', id: '調查探勘-其它' }],
    },
  ],
  [
    {
      name: '鋪纜',
      id: '調查探勘',
      list: [{ name: '輸出', id: '調查探勘-輸出' }, { name: '陣列', id: '調查探勘-陣列' }, { name: '其它(Ex:挖溝、犁埋等)', id: '調查探勘-其它(Ex:挖溝、犁埋等)' }],
    },
    {
      name: '水下基礎',
      id: '水下基礎',
      list: [{ name: '主要安裝', id: '水下基礎-主要安裝' }, { name: '運輸', id: '水下基礎-運輸' }, { name: '其它(Ex:定錨、拋石等)', id: '水下基礎-其它(Ex:定錨、拋石等)' }],
    },
    {
      name: '海上變電站',
      id: '海上變電站',
      list: [{ name: '主要安裝', id: '海上變電站-主要安裝' }, { name: '運輸', id: '海上變電站-運輸' }, { name: '其它', id: '海上變電站-其它' }],
    },
    {
      name: '風力機',
      id: '風力機',
      list: [{ name: '主要安裝', id: '風力機-主要安裝' }, { name: '運輸', id: '風力機-運輸' }, { name: '其它', id: '風力機-其它' }],
    },
  ],
  [
    {
      name: '人員運輸船',
      id: '人員運輸船',
      list: [{ name: 'CTV', id: '人員運輸船-CTV' }, { name: 'SOV', id: '人員運輸船-SOV' }, { name: '其它', id: '人員運輸船-其它' }],
    },
    {
      name: '其它輔助船',
      id: '其它輔助船',
    },
  ],
];
